// extracted by mini-css-extract-plugin
export default {"Prefecture":"prefecture_Prefecture__Eb0NQ"};